<template>
  <div class="seo-inner">
    <div
      v-if="text"
      v-html="text"
    />
  </div>
</template>

<script lang="ts" setup>
  import { computed } from 'vue';

  import { useSeoEntity } from '@/entities/seo';

  const seoEntity = useSeoEntity();
  const text = computed(() => seoEntity.seo?.text);
</script>

<style lang="scss" scoped>
  .seo-inner {
    display: grid;
    gap: 32px;
  }
</style>
